import { useGetIdentity } from '@refinedev/core';
import { DriverProfile } from 'pages/profile/types';

export const useGetDriverName = () => {
  const profile = useGetIdentity<DriverProfile>();
  return profile?.data?.name || '';
};
